import strings from "../../global/constants/StringConstants";
import urls from "../../global/constants/UrlConstants";
import { CompletedItemObject } from "../../models/CompletedItemObject";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../utils/service";
import { store } from "../../utils/store";
import MomentHelpers from "../../helpers/MomentHelpers";

export async function getFrequentlyOrderedItems() {
  try {
    const headers = {
      restaurantId: store.getState().menu.restaurantId,
      mode: strings.DINEIN,
    };
    const callParams = getNoAuthCallParams(strings.GET, headers);
    const response: any = await makeCall(
      urls.GETFREQUENTLYORDEREDITEMS,
      callParams
    )!;
    return response;
  } catch (error: any) {
    throw error;
  }
}

export const validateItemsAndModifiers = async () => {
  try {
    const headers = {
      restaurantid: store.getState().menu.restaurantId,
      mode: strings.DINEIN,
    };
    const body = {
      addedItems: store.getState().menu.addedItems,
    };
    const callParams = getNoAuthCallParams(strings.POST, headers, body);
    const response: any = await makeCall(
      urls.VALIDATEITEMSANDMODIFIERS,
      callParams
    )!;
    return response;
  } catch (error: any) {
    throw error;
  }
};

export async function checkForPaymentMethod() {
  try {
    const headers = { sessionid: store.getState().menu.sessionId };
    const callParams = await getCallParams(strings.GET, headers);
    const response: any = await makeCall(urls.CHECKPAYMENTMETHOD, callParams)!;
    return response;
  } catch (error: any) {
    throw error;
  }
}
